import { featureCards } from '@/mocks/siteData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Beautifully%20organized%20product%20shelves%20with%20fashion%20items%20neatly%20displayed%20on%20a%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20retail%20aesthetic%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20boutique%20product%20display%20photography&width=800&height=500&seq=vigorbuy-feat-discovery&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Close-up%20detail%20shot%20of%20fabric%20texture%20and%20stitching%20on%20elegant%20clothing%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20precision%20inspection%20photography%2C%20minimalist%20quality%20control%20aesthetic%2C%20clean%20macro%20composition&width=800&height=500&seq=vigorbuy-feat-quality&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20laptop%20showing%20organized%20spreadsheet%20data%20next%20to%20a%20notebook%20and%20coffee%20on%20a%20clean%20desk%2C%20warm%20natural%20window%20light%2C%20cozy%20productive%20workspace%2C%20minimalist%20lifestyle%20photography%2C%20cream%20neutral%20background%2C%20peaceful%20learning%20environment&width=800&height=500&seq=vigorbuy-feat-tutorial&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Secure%20digital%20workspace%20with%20laptop%20showing%20verified%20badges%20and%20lock%20icons%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20trust%20and%20security%20concept%2C%20clean%20minimalist%20desk%20setup%2C%20protected%20online%20environment%20photography&width=800&height=500&seq=vigorbuy-feat-safety&orientation=landscape',
];

export default function FeatureCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Everything You Need To Master Vigorbuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            Four pillars to help you discover, research, learn and stay safe while using Vigorbuy Spreadsheet resources.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureCards.map((card, idx) => (
            <div
              key={idx}
              className="group relative bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={cardImages[idx]}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${card.icon} text-primary-600 text-lg`}></i>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2.5">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}